import { Theme } from '@descope/page-editor-components';
import { Box, Grid } from '@mui/material';
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import DnDMessage from './DnDMessage';
import LogoBox from './LogoBox';
import { UpdateLogo } from './types';

type Props = {
	logo: Theme['logo'];
	updateLogo: UpdateLogo;
};

const Logo: React.FC<Props> = ({ logo, updateLogo }) => {
	const isLogo = !!logo?.['logo-url'];

	const onChange = useCallback(
		(files: File[]) => {
			const reader = new FileReader();
			reader.onload = () => {
				if (reader.result) {
					updateLogo(reader.result.toString(), 'logo-url');
				}
			};
			if (files[0]) reader.readAsDataURL(files[0]);
		},
		[updateLogo]
	);

	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop: onChange,
		multiple: false,
		accept: { 'image/*': [] }
	});

	return (
		<Box
			sx={{
				border: 'dashed',
				opacity: isDragActive ? 0.5 : 1,
				transition: 'opacity 0.2s ease-in-out',
				overflow: 'hidden'
			}}
			data-testid="logo-drop-zone"
			{...getRootProps()}
		>
			<Grid container spacing={2} height={130}>
				{isLogo && (
					<Grid item xs={8} height="100%">
						<LogoBox />
					</Grid>
				)}
				<Grid item xs={isLogo ? 4 : 12}>
					<DnDMessage />
				</Grid>
			</Grid>
			<input type="file" accept="image/*" hidden {...getInputProps()} />
		</Box>
	);
};

export default Logo;
